import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute } from "@angular/router";
import { ContactUsService } from "src/app/Forms/contact-us.service";
import { environment } from "src/environments/environment";
import { EncryptDecryptService } from "../../encrypt-decrypt.service";
import { MembershipService } from "../../membership/membership.service";
import { PaymentService } from "./payment.service";
import * as socketIo from "socket.io-client";

declare let paypal: any;

@Component({
  selector: "app-payment",
  templateUrl: "./payment.component.html",
  styleUrls: ["./payment.component.css"],
})
export class PaymentComponent implements OnInit {
  AppointmentDetails;
  AppointmentScheduleSlotLevelID;
  Amount = 0.0;
  addScript: boolean = false;
  paypalLoad: boolean = true;
  beforeSuccess = true;
  socket;
  videoCdnUrl = environment.googleCDNUrl;

  constructor(
    private paymentService: PaymentService,
    private _snackBar: MatSnackBar,
    private encDecService: EncryptDecryptService,
    private membershipService: MembershipService,
    private route: ActivatedRoute,
    private contactUsService: ContactUsService
  ) {}

  paypalConfig = {
    style: {
      size: "responsive",
    },
    env: environment.env,
    mode: environment.mode,
    client: {
      sandbox: environment.PayPalUrl,
      production: environment.PayPalUrl,
    },
    commit: true,
    payment: (data, actions) => {
      return actions.payment.create({
        payment: {
          transactions: [{ amount: { total: this.Amount, currency: "GBP" } }],
        },
      });
    },
    onAuthorize: (data, actions) => {
      return actions.payment.execute().then((payment) => {
        var PatientDetails = {
          StaffID: this.AppointmentDetails.StaffID,
          ReasonID: this.AppointmentDetails.ReasonID,
          PatientID: this.AppointmentDetails.PatientID,
          IsNHS: this.AppointmentDetails.IsNHS,
          Duration: this.AppointmentDetails.SlotDuration,
          StartTime: this.AppointmentDetails.SlotTime,
          Date: this.AppointmentDetails.Date,
          IsPending: 1,
        };
        this.InsertPatientAndSlot(
          PatientDetails,
          payment,
          1,
          this.AppointmentDetails.PatientID
        );
      });
    },
    onCancel: (data, actions) => {
      var PatientDetails = {
        StaffID: this.AppointmentDetails.StaffID,
        ReasonID: this.AppointmentDetails.ReasonID,
        PatientID: this.AppointmentDetails.PatientID,
        IsNHS: this.AppointmentDetails.IsNHS,
        Duration: this.AppointmentDetails.SlotDuration,
        StartTime: this.AppointmentDetails.SlotTime,
        Date: this.AppointmentDetails.Date,
        IsPending: 1,
      };
      this.InsertPatientAndSlot(
        PatientDetails,
        data,
        3,
        this.AppointmentDetails.PatientID
      );
    },
    onError: (err) => {
      var PatientDetails = {
        StaffID: this.AppointmentDetails.StaffID,
        ReasonID: this.AppointmentDetails.ReasonID,
        PatientID: this.AppointmentDetails.PatientID,
        IsNHS: this.AppointmentDetails.IsNHS,
        Duration: this.AppointmentDetails.SlotDuration,
        StartTime: this.AppointmentDetails.SlotTime,
        Date: this.AppointmentDetails.Date,
        IsPending: 1,
      };
      this.InsertPatientAndSlot(
        PatientDetails,
        err,
        2,
        this.AppointmentDetails.PatientID
      );
    },
  };

  addPaypalScript() {
    this.addScript = true;
    return new Promise((resolve, reject) => {
      let scripttagElement = document.createElement("script");
      scripttagElement.src = "https://www.paypal.com/api/checkout.js";
      scripttagElement.onload = resolve;
      document.body.appendChild(scripttagElement);
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((param) => {
      this.AppointmentScheduleSlotLevelID = param["id"];
      this.Amount = parseFloat(param["Amount"]);
    });
    if (this.Amount !== 0) {
      if (this.AppointmentScheduleSlotLevelID) {
        this.AppointmentScheduleSlotLevelID = parseInt(
          this.encDecService.dec(this.AppointmentScheduleSlotLevelID)
        );
      }
      this.GetAppointmentDetails();
    }
  }

  GetAppointmentDetails() {
    this.paymentService
      .GetAllAppointmentScheduleSlotLevelDetailsByAppointmentScheduleSlotLevelID(
        this.AppointmentScheduleSlotLevelID
      )
      .subscribe(
        (res) => {
          if (res["success"]) {
            res["data"] = JSON.parse(this.encDecService.dec(res["data"]));
            if (res["data"] && res["data"].length > 0) {
              this.AppointmentDetails = res["data"][0];
              if (
                this.AppointmentDetails &&
                this.AppointmentDetails.PaidStatus === 0
              ) {
                if (!this.addScript) {
                  this.addPaypalScript().then(() => {
                    paypal.Button.render(this.paypalConfig, "#proceedToPay");
                    this.paypalLoad = false;
                  });
                }
              }
            } else {
              this.AppointmentDetails = [];
            }
          } else {
            this.AppointmentDetails = [];
          }
        },
        (err) => {
          this.AppointmentDetails = [];
        }
      );
  }

  CloseTab() {
    window.top.close();
  }

  InsertPatientAndSlot(
    PatientDetails,
    TransactionDetail,
    PaidStatus,
    PatientID
  ) {
    var TransactionData = {
      AppointmentScheduleSlotLevelID: this.AppointmentScheduleSlotLevelID,
      PatientID: this.AppointmentDetails.PatientID,
      TransactionDetail: TransactionDetail,
      Deposit: 0,
      Price: this.Amount,
      PaidStatus: PaidStatus,
    };
    this.membershipService.InsertTransaction(TransactionData).subscribe(
      (res) => {
        if (res["success"]) {
          if (PaidStatus === 1) {
            this.beforeSuccess = false;
            // this.sendNotification()
          } else if (PaidStatus === 2) {
            this._snackBar.open(environment.errorMessage, "", {
              duration: 5000,
              panelClass: ["text-danger", "font2"],
              horizontalPosition: "right",
              verticalPosition: "top",
            });
          } else {
            // this.sendNotification()

            this._snackBar.open("You have cancelled the payment", "", {
              duration: 5000,
              panelClass: ["text-danger", "font2"],
              horizontalPosition: "right",
              verticalPosition: "top",
            });
          }
        } else {
          this._snackBar.open(environment.errorMessage, "", {
            duration: 5000,
            panelClass: ["text-danger", "font2"],
            horizontalPosition: "right",
            verticalPosition: "top",
          });
        }
      },
      (err) => {
        this._snackBar.open(environment.errorMessage, "", {
          duration: 5000,
          panelClass: ["text-danger", "font2"],
          horizontalPosition: "right",
          verticalPosition: "top",
        });
      }
    );
  }

  sendNotification() {
    this.socket = socketIo.connect(environment.configSocketUrlStaff);
    this.contactUsService
      .GetStaffWithAppointmentTransferPermission()
      .subscribe((res) => {
        if (res["success"]) {
          if (res["data"] && res["data"].length > 0) {
            res["data"].forEach((element) => {
              var result = {
                SocketId: element.SocketID,
                AppointmentDate: new Date(this.AppointmentDetails.Date),
                AppointmentStartTime: new Date(
                  this.AppointmentDetails.StartTime
                ).toLocaleTimeString(),
                AppointmentScheduleSlotLevelID:
                  this.AppointmentScheduleSlotLevelID,
                PatientID: this.AppointmentDetails.PatientID,
                PatientName:
                  this.AppointmentDetails.Title +
                  " " +
                  this.AppointmentDetails.FirstName +
                  " " +
                  this.AppointmentDetails.LastName,
                StaffID: this.AppointmentDetails.StaffID,
                StaffName: this.AppointmentDetails.StaffName,
                currentDate: new Date(this.AppointmentDetails.Date),
              };
              this.socket.emit("AppointmentCreateNotification", result);
            });
          }
        }
      });
  }
}
